import {LanguageModel} from '../models/language.model';

export class LanguagesCodebook {
    static allLanguages:LanguageModel[] = [
        {
            id:33,
            name:'Language-slo',
            shortcut:'slo'
        },{
            id:1,
            name:'Language-alb',
            shortcut:'alb'
        },{
            id:2,
            name:'Language-ara',
            shortcut:'ara'
        },{
            id:3,
            name:'Language-arm',
            shortcut:'arm'
        },{
            id:4,
            name:'Language-bel',
            shortcut:'bel'
        },{
            id:5,
            name:'Language-bul',
            shortcut:'bul'
        },{
            id:6,
            name:'Language-cze',
            shortcut:'cze'
        },{
            id:7,
            name:'Language-dut',
            shortcut:'dut'
        },{
            id:8,
            name:'Language-eng',
            shortcut:'eng'
        },{
            id:9,
            name:'Language-esp',
            shortcut:'esp'
        },{
            id:10,
            name:'Language-est',
            shortcut:'est'
        },{
            id:11,
            name:'Language-fin',
            shortcut:'fin'
        },{
            id:12,
            name:'Language-fre',
            shortcut:'fre'
        },{
            id:13,
            name:'Language-geo',
            shortcut:'geo'
        },{
            id:14,
            name:'Language-ger',
            shortcut:'ger'
        },{
            id:15,
            name:'Language-heb',
            shortcut:'heb'
        },{
            id:16,
            name:'Language-hun',
            shortcut:'hun'
        },{
            id:17,
            name:'Language-chi',
            shortcut:'chi'
        },{
            id:18,
            name:'Language-ice',
            shortcut:'ice'
        },{
            id:19,
            name:'Language-ira',
            shortcut:'ira'
        },{
            id:20,
            name:'Language-iri',
            shortcut:'iri'
        },{
            id:21,
            name:'Language-ita',
            shortcut:'ita'
        },{
            id:22,
            name:'Language-jpn',
            shortcut:'jpn'
        },{
            id:23,
            name:'Language-lat',
            shortcut:'lat'
        },{
            id:24,
            name:'Language-lav',
            shortcut:'lav'
        },{
            id:25,
            name:'Language-lit',
            shortcut:'lit'
        },{
            id:26,
            name:'Language-pol',
            shortcut:'pol'
        },{
            id:27,
            name:'Language-por',
            shortcut:'por'
        },{
            id:28,
            name:'Language-rom',
            shortcut:'rom'
        },{
            id:29,
            name:'Language-rum',
            shortcut:'rum'
        },{
            id:30,
            name:'Language-rus',
            shortcut:'rus'
        },{
            id:31,
            name:'Language-scc',
            shortcut:'scc'
        },{
            id:32,
            name:'Language-scr',
            shortcut:'scr'
        },{
            id:34,
            name:'Language-slv',
            shortcut:'slv'
        },{
            id:35,
            name:'Language-spa',
            shortcut:'spa'
        },{
            id:36,
            name:'Language-swe',
            shortcut:'swe'
        },{
            id:37,
            name:'Language-ukr',
            shortcut:'ukr'
        }
        ]
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/codebook/languages-codebook.ts